
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 54","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".4","d":"M36.719 13.281V20H0v-6.719h36.719zm0-13.281v6.719H0V0h36.719zM0 33.281V26.72h23.281v6.562H0zm37.969 20l-4.688-4.687L42.031 40l-8.75-8.594 4.688-4.687 8.75 8.593 8.593-8.593L60 31.406 51.406 40 60 48.594l-4.688 4.687-8.593-8.593-8.75 8.593z"}})])
          )
        }
      }
    